import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentAcknowledgementService from "../../services/riskAssessmentAcknowledgementService";

const useRiskAssessmentAcknowledgementDetails = ({ reference }) =>
    useQuery(
        [queryKeys.riskAssessmentAcknowledgementDetails, reference],
        () => riskAssessmentAcknowledgementService.getDetailsByReference({ reference }),
        { enabled: !!reference, retry: false }
    );

export default useRiskAssessmentAcknowledgementDetails;
